import { Component, ContentChild, EventEmitter, Input, OnInit, Output, Pipe, PipeTransform, TemplateRef } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'q-select-multiple',
  templateUrl: './select-multiple.component.html',
  styleUrls: ['./select-multiple.component.css']
})

//.l;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;.
//.l                                                                                    l.
//.l  elementsColumName                         selectedElementsColumName               l.
//.l                                                                                    l.
//.l  +--------------------------------+       t''+:::::::::::::::::::::::::::::::+''t  l.
//.l  l filtrer (filterableProperties) l       :  l (-) elementSelectedRef        l  :  l.
//.l  +--------------------------------+       :  +-------------------------------+  :  l.
//.l                                           :  +-------------------------------+  :  l.
//.l  +-------------------------------+        :  l (-) elementSelectedRef        l  :  l.
//.l  l (+) elementListRef            l        :  +-------------------------------+  :  l.
//.l  +-------------------------------+        :                                     :  l.
//.l  +-------------------------------+        :                                     :  l.
//.l  l (+) elementListRef            l        :                                     :  l.
//.l  +-------------------------------+        :                                     :  l.
//.l  +-------------------------------+        :                                     :  l.
//.l  l (+) elementListRef            l        :                                     :  l.
//.l  +-------------------------------+        :.....................................:  l.
//.l                                                                                    l.
//.l;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;.

export class SelectMultipleComponent implements OnInit {
  // liste des éléments affichés (non sélectionnés)
  public elementsList: Array<any> = new Array<any>();
  //liste des éléments sélectionnés
  public selectedElementsList: Array<any> = new Array<any>();
  private _initSelectedElementsList: Array<any> = new Array<any>();
  public filter: string = '';
  //liste des propriétés filtrable dans elementsList
  //ex:
  //{
  //  Nom: string,
  //  ContactPrincipal: ContactPrincipalModel
  //    {
  //       Nom: string,
  //       Tel: string
  //    }
  //}
  //['Nom', 'ContactPrincipal|Tel'] => recherche la valeur dans le nom et dans le tel du ContactPrincipal
  public filterableProperties: Array<string> = [];

  //liste des triables filtrable dans elementsList
  // même fonctionnement que filterableProperties
  public SortablesProperties: Array<string> = [];

  //permet de définir le HTML de la liste des éléments NON sélectionnés avec :
  //<ng-template let-element #elementList> </ng-template>
  //avec let-element => elementsList[index]
  @ContentChild('elementList', { static: false }) elementListRef: TemplateRef<any>;

  //permet de définir le HTML de la liste des éléments sélectionnés avec :
  //<ng-template let-element #elementSelected> </ng-template>
  //avec let-element => selectedElementsList[index]
  @ContentChild('elementSelected', { static: false }) elementSelectedRef: TemplateRef<any>;

  //Nom de l'entête de la colonne de gauche (éléments non sélectionnés)
  @Input("elementsColumName") elementsColumName: string;
  //Nom de l'entête de la colonne de droite (éléments sélectionnés)
  @Input("selectedElementsColumName") selectedElementsColumName: string;
  //Liste d'éléments à afficher
  @Input("elementsList") set SetElementsList(value: Array<any>) {
    this.elementsList = JSON.parse(JSON.stringify(value));
  }
  //Liste d'éléments sélectionnés
  @Input("selectedElementsList") set SetSelectedElementsList(value: Array<any>) {
    this._initSelectedElementsList = JSON.parse(JSON.stringify(value));
  }
  
  //Liste des propriétés sur lesquels appliquer le filtre de recherche
  @Input("filterableProperties") set SetFilterableProperties(value: Array<string>) {
    if (value) {
      this.filterableProperties = value;
    }
  }
  @Input("SortablesProperties") set SetSortablesProperties(value: Array<string>) {
    if (value) {
      this.SortablesProperties = value;
    }
  }

  @Input("disabled") disabled: boolean;
  //retourne :
  // {
  //  public selectedValues: Array<any>;  => nouvelle liste d'éléments sélectionnés
  //  public value: any;                  => élément cliqué
  //  public added: boolean;              => pour l'élément cliqué, true si ajouté et false si retiré
  //}
  @Output() selectChange: EventEmitter<selectMultipleChange> = new EventEmitter<selectMultipleChange>(true);

  // #region CONSTRUCTEUR
  constructor(
    public sanitizer: DomSanitizer,
  ) { }
  // #endregion

  public ngOnInit(): void {
    if (this._initSelectedElementsList) {
      this._initSelectedElementsList.forEach(el => {
        this.selectedElementsList.push(el);
      });      
      if (this.SortablesProperties && this.SortablesProperties.length > 0) {
        this.Sort(this.elementsList);
        this.Sort(this.selectedElementsList);
      }
    }
  }
  // #endregion
  /**
   * retire l'élément de elementsList et le place dans selectedElementsList
   * @param element élément à déplacer
   * @param index index dans la liste elementsList
   */
  public AddElement(element: any, index: number): void {
    // retire l'élément de la liste d'origine
    this.elementsList.splice(index, 1);
    // réafecte la liste pour activer le pipe
    this.elementsList = JSON.parse(JSON.stringify(this.elementsList));
    // pousse l'élément dans la liste des éléments sélectionnés
    this.selectedElementsList.push(element);

    // tri les listes
    if (this.SortablesProperties && this.SortablesProperties.length > 0) {
      this.Sort(this.elementsList);
      this.Sort(this.selectedElementsList);
    }

    // emit la nouvelle liste (sélectionnés), l'élément et qu'il a été ajouté
    const value: selectMultipleChange = {
      added: true,
      selectedValues: this.selectedElementsList,
      value: element
    }
    this.selectChange.emit(value);
  }

  /**
   * retire l'élément de selectedElementsList et le replace dans elementsList
   * @param element élément à déplacer
   * @param index index dans la liste selectedElementsList
   */
  public RemoveElement(element: any, index: number): void {
    // retire l'élément de la liste des éléments sélectionnés
    this.selectedElementsList.splice(index, 1);
    // pousse l'élément dans la liste d'origine
    this.elementsList.push(element);
    // réafecte la liste pour activer le pipe
    this.elementsList = JSON.parse(JSON.stringify(this.elementsList));

    // tri les listes
    if (this.SortablesProperties && this.SortablesProperties.length > 0) {
      this.Sort(this.elementsList);
      this.Sort(this.selectedElementsList);
    }

    // emit la nouvelle liste (sélectionnés), l'élément et qu'il a été retiré
    const value: selectMultipleChange = {
      added: false,
      selectedValues: this.selectedElementsList,
      value: element
    }
    this.selectChange.emit(value);
  }

  /**
   * méthode de tri
   * @param list objet de type liste à trier (doit contenir les propriétés/sous-propriétés indiquées dans this.SortablesProperties)
   */
  private Sort(list: Array<any>): void {
    list.sort((a: any, b: any) => {
      let compare: number = 0;
      //pour chaque propriété triable passée en paramètre (input: SortablesProperties)
      for (let i: number = 0; i < this.SortablesProperties.length; i++) {
        let valueAToSort: any = a;
        let valueBToSort: any = b;
        //on split l'arborescence (ex: Client.Contact.NumTel s'écrit => 'Contact|NumTel')
        const properties: Array<string> = this.SortablesProperties[i].split('|');
        //on va chercher la valeur en bouclant sur chaque objet enfant jusqu'à arriver à la propriété souhaitée.
        properties.forEach((prop) => {
          //ex:         valueAToSort == Client
          //   puis     valueAToSort == Contact
          //   et enfin valueAToSort == NumTel
          valueAToSort = valueAToSort[prop];
          valueBToSort = valueBToSort[prop];
        });

        if (!valueAToSort && valueAToSort !== '') return -1;
        if (!valueBToSort && valueBToSort !== '') return 1;
        compare = valueAToSort.localeCompare(valueBToSort);
        if (compare != 0) return compare;
      }
      return compare;
    });
  }
}

@Pipe({ name: 'FilterElements' })
export class FilterProperty implements PipeTransform {
  constructor(public cd: ChangeDetectorRef) { }
  /**
   * pipe de filtre des éléments (non sélectionnés)
   * @param elements liste des éléments à trier (doit contenir les propriétés/sous-propriétés indiquées dans l'input filterableProperties)
   * @param filter valeur que doit contenir les propriétés des éléments
   * @param filterableProperties propriétés à vérifier pour le filtre
   */
  transform(elements: Array<any>, filter: string, filterableProperties: Array<string>): any[] {
    this.cd.detectChanges();

    let filteredProperties: Array<{ index: number, value: any }> = new Array<{ index: number, value: any }>();
    let index: number = 0;
    if (elements) {
      elements.forEach((value: any) => {
        let addable: boolean = false;
        //pour chaque propriété on va venir définir la valueToFilter
        for (let i: number = 0; i < filterableProperties.length; i++) {
          let valueToFilter: any = value;
          //on split l'arborescence (ex: Client.Contact.NumTel s'écrit => 'Contact|NumTel')
          const properties: Array<string> = filterableProperties[i].split('|');
          //on va chercher la valeur en bouclant sur chaque objet enfant jusqu'à arriver à la propriété souhaitée.
          properties.forEach((prop) => {
            //ex:         valueToFilter == Client
            //   puis     valueToFilter == Contact
            //   et enfin valueToFilter == NumTel
            valueToFilter = valueToFilter[prop];
          });
          // si la valeur à filtrer contient la valeur passée en paramètre, l'élément est ajoutable à la liste donc on peut break.
          if (`${valueToFilter}`.toLocaleLowerCase().includes(filter.toLocaleLowerCase())) {
            addable = true;
            break;
          }
        }
        // si il n'y a pas de filtre toutes les propriétés sont affichées,
        //sinon seules celle définies comme ajoutables le sont.
        if (!filter || addable) {
          filteredProperties = [...filteredProperties, { index, value }];
        }
        index++;
      });
    }

    this.cd.detectChanges();

    return filteredProperties;
  }
}

//modèle de retour en output
export class selectMultipleChange {
  public selectedValues: Array<any>;
  public value: any;
  public added: boolean;
}
